var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDae(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 300,
    viewBox: "0 0 380 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M60 181.086V179.461C76.1015 179.461 89.201 166.361 89.201 150.26C89.201 134.158 76.1015 121.059 60 121.059V119.434C76.9957 119.434 90.8262 133.262 90.8262 150.26C90.8262 167.257 76.9957 181.086 60 181.086Z",
    fill: "#274522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 178.091V176.465C74.2793 176.465 85.8937 164.849 85.8937 150.572C85.8937 136.294 74.2793 124.678 60 124.678V123.053C75.1753 123.053 87.519 135.398 87.519 150.572C87.519 165.745 75.1753 178.091 60 178.091Z",
    fill: "#274522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 174.593V172.967C72.3507 172.967 82.3966 162.92 82.3966 150.571C82.3966 138.222 72.3507 128.174 60 128.174V126.549C73.2449 126.549 84.0219 137.324 84.0219 150.571C84.0219 163.817 73.2449 174.593 60 174.593Z",
    fill: "#274522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 171.222V169.596C70.4895 169.596 79.0255 161.062 79.0255 150.571C79.0255 140.08 70.4895 131.547 60 131.547V129.922C71.3873 129.922 80.649 139.187 80.649 150.571C80.649 161.955 71.3873 171.222 60 171.222Z",
    fill: "#274522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 167.786V166.16C68.5946 166.16 75.5888 159.168 75.5888 150.572C75.5888 141.975 68.5946 134.985 60 134.985V133.359C69.4906 133.359 77.2122 141.079 77.2122 150.57C77.2122 160.06 69.4906 167.786 60 167.786Z",
    fill: "#274522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 184.226V182.601C77.8332 182.601 92.3432 168.093 92.3432 150.258C92.3432 132.423 77.8332 117.918 60 117.918V116.293C78.731 116.293 93.9667 131.53 93.9667 150.258C93.9667 168.985 78.731 184.226 60 184.226Z",
    fill: "#274522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 187.048V185.423C79.3892 185.423 95.1643 169.65 95.1643 150.26C95.1643 130.871 79.3892 115.098 60 115.098V113.473C80.2835 113.473 96.7895 129.975 96.7895 150.262C96.7895 170.549 80.2835 187.048 60 187.048Z",
    fill: "#274522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60 164.434V163.126C66.9214 163.126 72.5547 157.495 72.5547 150.574C72.5547 143.652 66.9214 138.021 60 138.021V136.713C67.6436 136.713 73.8624 142.93 73.8624 150.574C73.8624 158.217 67.6436 164.434 60 164.434Z",
    fill: "#274522"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.021 170.716V174.495H222.692V178.37H216.021V182.364H223.794V186.227H212.133V166.891H223.794V170.716H216.021Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.749 176.186L225.231 166.891H229.693L233.004 172.744L236.301 166.891H240.765L235.234 176.175L241.125 186.227H236.662L232.992 179.736L229.333 186.227H224.869L230.749 176.186Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.702 166.89H249.492C253.236 166.89 256.293 169.829 256.293 173.427C256.293 177.025 253.236 179.94 249.492 179.94H246.59V186.226H242.702V166.889V166.89ZM252.407 173.391C252.407 171.928 251.1 170.741 249.492 170.741H246.59V176.09L249.492 176.102C251.1 176.117 252.407 174.892 252.407 173.393",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.285 176.581C257.285 171.026 261.808 166.494 267.338 166.494C272.868 166.494 277.402 171.026 277.402 176.581C277.402 182.136 272.868 186.597 267.326 186.597C261.783 186.597 257.287 182.086 257.287 176.581M273.468 176.558C273.468 173.174 270.709 170.415 267.326 170.415C263.942 170.415 261.208 173.174 261.208 176.558C261.208 179.941 263.954 182.663 267.326 182.663C270.697 182.663 273.468 179.917 273.468 176.558Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.688 123.294C227.688 129.293 223.874 132.939 217.623 132.939H211.997V113.614L217.623 113.602C223.874 113.589 227.688 117.26 227.688 123.294ZM223.765 123.282C223.765 119.659 221.436 117.452 217.61 117.452H215.87V129.063H217.646C221.445 129.063 223.764 126.88 223.764 123.282",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.546 113.604V132.941H240.673V125.191H233.726V132.941H229.853V113.604H233.726V121.341H240.673V113.604H244.546Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.293 130.241H251.558L250.321 132.94H246.123L255.358 113.125H255.479L264.728 132.94H260.516L259.292 130.241H259.293ZM257.784 126.931L255.431 121.76L253.068 126.931H257.784Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M276.059 132.939L270.18 124.471V132.939H266.305V113.602H270.18V121.962L275.613 113.602H280.1L273.899 123.067L280.783 132.939H276.059Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.021 130.241H286.285L285.049 132.94H280.851L290.088 113.125H290.208L299.458 132.94H295.245L294.021 130.241ZM292.511 126.931L290.159 121.76L287.795 126.931H292.511Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M224.867 157.068H217.131L215.895 159.766H211.697L220.932 139.951H221.053L230.302 159.766H226.09L224.865 157.068H224.867ZM223.357 153.757L221.005 148.587L218.641 153.757H223.357Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.879 140.43H238.669C242.413 140.43 245.472 143.368 245.472 146.966C245.472 150.564 242.413 153.479 238.669 153.479H235.767V159.766H231.879V140.428V140.43ZM241.584 146.93C241.584 145.467 240.277 144.28 238.669 144.28H235.767V149.629L238.669 149.642C240.277 149.656 241.584 148.431 241.584 146.932",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.301 140.43H254.091C257.835 140.43 260.894 143.368 260.894 146.966C260.894 150.564 257.835 153.479 254.091 153.479H251.188V159.766H247.301V140.428V140.43ZM257.006 146.93C257.006 145.467 255.699 144.28 254.091 144.28H251.188V149.629L254.091 149.642C255.699 149.656 257.006 148.431 257.006 146.932",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M270.869 157.068H263.133L261.896 159.766H257.698L266.933 139.951H267.054L276.303 159.766H272.091L270.867 157.068H270.869ZM269.359 153.757L267.006 148.587L264.643 153.757H269.359Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.934 159.766L281.779 150.626V159.766H277.893L277.879 140.43H284.19C287.801 140.43 290.764 143.212 290.764 146.691C290.764 149.173 289.264 151.345 287.189 152.076L292.683 159.766H287.934ZM281.768 149.138L284.265 149.15C285.583 149.163 286.757 148.096 286.757 146.716C286.757 145.336 285.57 144.282 284.265 144.282H281.768V149.14V149.138Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298.065 144.257V148.034H304.734V151.909H298.065V155.903H305.836V159.767H294.179V140.43H305.836V144.257H298.065Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M320 155.903V159.766H308.34V140.43H312.227V155.903H320Z",
    fill: "#171717"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.314 117.896V120.722L188.482 116.677L192.653 120.722C192.653 120.722 192.788 117.896 192.653 117.852C192.518 117.807 188.514 113.764 188.514 113.764L184.314 117.896Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.314 126.005V128.832L188.482 124.786L192.653 128.832C192.653 128.832 192.788 126.005 192.653 125.961C192.518 125.917 188.514 121.873 188.514 121.873L184.314 126.005Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.897 121.125V118.299L193.065 122.344L197.236 118.299C197.236 118.299 197.371 121.125 197.236 121.17C197.101 121.214 193.097 125.258 193.097 125.258L188.897 121.125Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.751 121.125V118.299L183.919 122.344L188.09 118.299C188.09 118.299 188.225 121.125 188.09 121.17C187.955 121.214 183.951 125.258 183.951 125.258L179.751 121.125Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.739 113.641L193.539 117.773V120.599L197.708 116.556",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.739 121.777L193.539 125.91V128.736L197.708 124.692",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.069 130.105L183.869 134.236V137.064L188.04 133.021",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.069 163.146L183.869 167.277V170.105L188.04 166.062",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.314 142.591V145.418L188.482 141.372L192.653 145.418C192.653 145.418 192.788 142.591 192.653 142.547C192.518 142.503 188.514 138.459 188.514 138.459L184.314 142.591Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.739 138.363L193.539 142.496V145.322L197.708 141.278",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.314 150.609V153.435L188.482 149.39L192.653 153.435C192.653 153.435 192.788 150.609 192.653 150.564C192.518 150.52 188.514 146.477 188.514 146.477L184.314 150.609Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.739 146.605L193.539 150.514V153.341L197.708 149.295",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.314 158.992V161.818L188.482 157.773L192.653 161.818C192.653 161.818 192.788 158.992 192.653 158.947C192.518 158.903 188.514 154.859 188.514 154.859L184.314 158.992Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.739 154.766L193.539 158.896V161.724L197.708 157.681",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.603 129.217V126.391L174.771 130.436L178.942 126.391C178.942 126.391 179.077 129.217 178.942 129.261C178.807 129.306 174.802 133.349 174.802 133.349L170.603 129.217Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.599 137.428V134.602L174.767 138.647L178.938 134.602C178.938 134.602 179.073 137.428 178.938 137.472C178.803 137.517 174.799 141.56 174.799 141.56L170.599 137.428Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.671 137.428V134.602L183.839 138.647L188.01 134.602C188.01 134.602 188.145 137.428 188.01 137.472C187.875 137.517 183.871 141.56 183.871 141.56L179.671 137.428Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.671 129.217V126.391L183.839 130.436L188.01 126.391C188.01 126.391 188.145 129.217 188.01 129.261C187.875 129.306 183.871 133.349 183.871 133.349L179.671 129.217Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.08 145.765V142.938L193.248 146.983L197.739 142.383V145.323C197.772 145.316 193.28 149.895 193.28 149.895L189.08 145.763V145.765Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.815 145.824V142.998L183.982 147.043L188.154 142.998C188.154 142.998 188.289 145.824 188.154 145.869C188.019 145.913 184.014 149.957 184.014 149.957L179.815 145.824Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.828 153.976V151.148L192.998 155.193L197.737 150.738V153.455L193.028 158.107L188.828 153.976Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.795 153.977V151.15L183.963 155.196L188.134 151.15C188.134 151.15 188.269 153.977 188.134 154.021C187.999 154.066 183.995 158.109 183.995 158.109L179.795 153.977Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.018 117.896V120.722L170.186 116.677L174.357 120.722C174.357 120.722 174.492 117.896 174.357 117.852C174.222 117.807 170.218 113.764 170.218 113.764L166.018 117.896Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.018 126.005V128.832L170.186 124.786L174.357 128.832C174.357 128.832 174.492 126.005 174.357 125.961C174.222 125.917 170.218 121.873 170.218 121.873L166.018 126.005Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.599 121.125V118.299L174.767 122.344L178.938 118.299C178.938 118.299 179.073 121.125 178.938 121.17C178.803 121.214 174.799 125.258 174.799 125.258L170.599 121.125Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.603 154.026V151.199L174.771 155.245L178.942 151.199C178.942 151.199 179.077 154.026 178.942 154.07C178.807 154.114 174.802 158.158 174.802 158.158L170.603 154.026Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.599 162.239V159.412L174.767 163.457L178.938 159.412C178.938 159.412 179.073 162.239 178.938 162.283C178.803 162.327 174.799 166.371 174.799 166.371L170.599 162.239Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.366 162.239V159.412L183.533 163.457L187.705 159.412C187.705 159.412 187.84 162.239 187.705 162.283C187.57 162.327 183.565 166.371 183.565 166.371L179.366 162.239Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.366 170.465V167.639L183.533 171.684L187.705 167.639C187.705 167.639 187.84 170.465 187.705 170.509C187.57 170.554 183.565 174.597 183.565 174.597L179.366 170.465Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.599 145.934V143.107L174.767 147.153L178.938 143.107C178.938 143.107 179.073 145.934 178.938 145.978C178.803 146.023 174.799 150.066 174.799 150.066L170.599 145.934Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.018 134.238V137.064L170.186 133.019L174.357 137.064C174.357 137.064 174.492 134.238 174.357 134.193C174.222 134.149 170.218 130.105 170.218 130.105L166.018 134.238Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.04 134.238V137.064L179.208 133.019L183.379 137.064C183.379 137.064 183.514 134.238 183.379 134.193C183.245 134.149 179.24 130.105 179.24 130.105L175.04 134.238Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.018 142.591V145.418L170.186 141.372L174.357 145.418C174.357 145.418 174.492 142.591 174.357 142.547C174.222 142.503 170.218 138.459 170.218 138.459L166.018 142.591Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.018 150.609V153.435L170.186 149.39L174.357 153.435C174.357 153.435 174.492 150.609 174.357 150.564C174.222 150.52 170.218 146.477 170.218 146.477L166.018 150.609Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.018 158.992V161.818L170.186 157.773L174.357 161.818C174.357 161.818 174.492 158.992 174.357 158.947C174.222 158.903 170.218 154.859 170.218 154.859L166.018 158.992Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.018 167.279V170.105L170.186 166.06L174.357 170.105C174.357 170.105 174.492 167.279 174.357 167.234C174.222 167.19 170.218 163.146 170.218 163.146L166.018 167.279Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.04 167.279V170.105L179.208 166.06L183.379 170.105C183.379 170.105 183.514 167.279 183.379 167.234C183.245 167.19 179.24 163.146 179.24 163.146L175.04 167.279Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.166 117.896V120.722L179.334 116.677L183.505 120.722C183.505 120.722 183.64 117.896 183.505 117.852C183.37 117.807 179.366 113.764 179.366 113.764L175.166 117.896Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.166 126.005V128.832L179.334 124.786L183.505 128.832C183.505 128.832 183.64 126.005 183.505 125.961C183.37 125.917 179.366 121.873 179.366 121.873L175.166 126.005Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.166 142.591V145.418L179.334 141.372L183.505 145.418C183.505 145.418 183.64 142.591 183.505 142.547C183.37 142.503 179.366 138.459 179.366 138.459L175.166 142.591Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.166 150.609V153.435L179.334 149.39L183.505 153.435C183.505 153.435 183.64 150.609 183.505 150.564C183.37 150.52 179.366 146.477 179.366 146.477L175.166 150.609Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.166 158.992V161.818L179.334 157.773L183.505 161.818C183.505 161.818 183.64 158.992 183.505 158.947C183.37 158.903 179.366 154.859 179.366 154.859L175.166 158.992Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.314 175.14V177.967L188.484 173.921L193.022 178.327V175.461L188.514 171.008L184.314 175.14Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.739 171.398L193.539 175.531V178.357L197.708 174.314",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.599 170.465V167.639L174.767 171.684L178.938 167.639C178.938 167.639 179.073 170.465 178.938 170.509C178.803 170.554 174.799 174.597 174.799 174.597L170.599 170.465Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M166.018 175.503V178.33L170.186 174.284L174.357 178.33C174.357 178.33 174.492 175.503 174.357 175.459C174.222 175.415 170.218 171.371 170.218 171.371L166.018 175.503Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.166 175.626V178.453L179.334 174.407L183.505 178.453C183.505 178.453 183.64 175.626 183.505 175.582C183.37 175.538 179.366 171.494 179.366 171.494L175.166 175.626Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.19 183.732V186.56L188.358 182.515L192.529 186.56V183.689L188.39 179.602L184.19 183.732Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.613 179.504L193.413 183.636V186.463L197.584 182.419",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.828 178.765V175.936L192.998 179.984L197.737 175.713L197.613 178.47L193.028 182.895L188.828 178.765Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.671 178.643V175.816L183.839 179.862L188.01 175.816C188.01 175.816 188.145 178.643 188.01 178.687C187.875 178.732 183.871 182.775 183.871 182.775L179.671 178.643Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.475 178.813V175.986L174.643 180.032L178.814 175.986C178.814 175.986 178.949 178.813 178.814 178.857C178.679 178.901 174.675 182.945 174.675 182.945L170.475 178.813Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.892 184.097V186.924L170.06 182.878L174.231 186.924C174.231 186.924 174.366 184.097 174.231 184.053C174.096 184.008 170.092 179.965 170.092 179.965L165.892 184.097Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M175.04 183.732V186.558L179.208 182.513L183.379 186.558C183.379 186.558 183.514 183.732 183.379 183.688C183.245 183.643 179.24 179.6 179.24 179.6L175.04 183.732Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.934 118.176L165.794 122.193V125.134C165.794 125.134 169.799 121.091 169.934 121.047C170.069 121.004 169.934 118.176 169.934 118.176Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.934 126.129L165.794 130.146V133.088C165.794 133.088 169.799 129.044 169.934 129C170.069 128.957 169.934 126.129 169.934 126.129Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.934 134.344L165.794 138.361V141.302C165.794 141.302 169.799 137.259 169.934 137.215C170.069 137.172 169.934 134.344 169.934 134.344Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.934 142.875L165.794 146.892V149.834C165.794 149.834 169.799 145.79 169.934 145.746C170.069 145.703 169.934 142.875 169.934 142.875Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.934 151.027L165.794 155.044V157.986C165.794 157.986 169.799 153.942 169.934 153.898C170.069 153.856 169.934 151.027 169.934 151.027Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.934 159.18L165.794 163.197V166.138C165.794 166.138 169.799 162.095 169.934 162.05C170.069 162.008 169.934 159.18 169.934 159.18Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.934 167.529L165.794 171.546V174.488C165.794 174.488 169.799 170.444 169.934 170.4C170.069 170.357 169.934 167.529 169.934 167.529Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.934 175.816L165.794 179.833V182.775C165.794 182.775 169.799 178.732 169.934 178.687C170.069 178.645 169.934 175.816 169.934 175.816Z",
    fill: "#F9A345"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.814 118.25L131.929 113.021L121.447 113L126.814 118.25Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.814 123.5L131.929 118.271L121.447 118.25L126.814 123.5Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.684 128.744L126.801 123.515L116.317 123.494L121.684 128.744Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.56 133.992L121.676 128.763L111.193 128.742L116.56 133.992Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.041 133.992L132.156 128.763L121.674 128.742L127.041 133.992Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.295 144.463L132.412 139.234L121.927 139.213L127.295 144.463Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.523 133.992L142.638 128.763L132.156 128.742L137.523 133.992Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.167 128.744L137.282 123.515L126.8 123.494L132.167 128.744Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.926 139.213L127.043 133.984L116.558 133.963L121.926 139.213Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.408 139.238L137.523 134.01L127.041 133.988L132.408 139.238Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.814 170.926L131.929 176.155L121.447 176.176L126.814 170.926Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.684 165.68L126.801 170.908L116.317 170.932L121.684 165.68Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.56 160.432L121.676 165.66L111.193 165.682L116.56 160.432Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.041 160.432L132.156 165.66L121.674 165.682L127.041 160.432Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.295 149.961L132.412 155.19L121.927 155.211L127.295 149.961Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.523 160.432L142.638 165.66L132.156 165.682L137.523 160.432Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.167 165.68L137.282 170.908L126.8 170.932L132.167 165.68Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.926 155.211L127.043 160.44L116.558 160.461L121.926 155.211Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.408 155.188L137.523 160.416L127.041 160.438L132.408 155.188Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.3747 181.42L99.49 186.649L89.0076 186.67L94.3747 181.42Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.903 181.406L110.019 186.635L99.5344 186.656L104.903 181.406Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.7739 176.162L104.889 181.391L94.4067 181.412L99.7739 176.162Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.6479 170.914L99.7649 176.141L89.2808 176.164L94.6479 170.914Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.13 170.914L110.246 176.141L99.7632 176.164L105.13 170.914Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.384 160.443L110.499 165.672L100.017 165.693L105.384 160.443Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.611 170.914L120.726 176.141L110.244 176.164L115.611 170.914Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.254 176.162L115.37 181.391L104.887 181.412L110.254 176.162Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.015 165.691L105.13 170.92L94.6479 170.943L100.015 165.691Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.496 165.668L115.611 170.897L105.129 170.918L110.496 165.668Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.438 181.406L163.554 186.635L153.071 186.656L158.438 181.406Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.958 181.406L153.073 186.635L142.589 186.656L147.958 181.406Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.828 176.162L147.944 181.391L137.461 181.412L142.828 176.162Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.704 170.914L142.819 176.141L132.335 176.164L137.704 170.914Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.185 170.914L153.3 176.141L142.818 176.164L148.185 170.914Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.438 160.443L153.554 165.672L143.071 165.693L148.438 160.443Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.666 170.914L163.781 176.141L153.298 176.164L158.666 170.914Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.309 176.162L158.424 181.391L147.942 181.412L153.309 176.162Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.07 165.691L148.185 170.92L137.702 170.943L143.07 165.691Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.55 165.668L158.667 170.897L148.183 170.918L153.55 165.668Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.206 146.818L100.977 151.934L100.956 141.451L106.206 146.818Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.45 141.687L106.221 146.803L106.2 136.32L111.45 141.687Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.701 136.564L111.472 141.68L111.45 131.197L116.701 136.564Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.701 147.045L111.472 152.16L111.45 141.678L116.701 147.045Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.169 147.299L121.94 152.414L121.918 141.932L127.169 147.299Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.701 157.525L111.472 162.641L111.45 152.158L116.701 157.525Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.45 152.17L106.221 157.285L106.2 146.801L111.45 152.17Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.92 141.93L116.691 147.045L116.67 136.562L121.92 141.93Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.945 152.41L116.716 157.527L116.695 147.043L121.945 152.41Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148.133 146.818L153.362 151.934L153.383 141.451L148.133 146.818Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.889 141.687L148.116 146.803L148.139 136.32L142.889 141.687Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.639 136.564L142.867 141.68L142.889 131.197L137.639 136.564Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.639 147.045L142.867 152.16L142.889 141.678L137.639 147.045Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.169 147.299L132.397 152.414L132.419 141.932L127.169 147.299Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.639 157.525L142.867 162.641L142.889 152.158L137.639 157.525Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.889 152.17L148.116 157.285L148.139 146.801L142.889 152.17Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.419 141.93L137.647 147.045L137.669 136.562L132.419 141.93Z",
    fill: "#EC3325"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.394 152.41L137.623 157.527L137.644 147.043L132.394 152.41Z",
    fill: "#EC3325"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 260,
    height: 74.0475,
    fill: "white",
    transform: "translate(60 113)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDae);
export default __webpack_public_path__ + "static/media/dae.b7d79f3e59d515e7071ebb9a53b2d916.svg";
export { ForwardRef as ReactComponent };